/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Outlet, RouteObject } from "react-router-dom";

import { ProtectedRoute } from "../../components/AppRouter/ProtectedRoute";
import { FlagGate } from "../../components/AppRouter/route-gates";
import { QuoteOrderSubmitted } from "../../pages/QuoteOrderSubmitted";
import Quotes from "../../pages/Quotes";
import { RequestAQuoteSuccess } from "../../pages/RequestAQuoteSuccess";
import { HOME_ROUTE } from "../../util/routing";

import {
  QUOTE_DETAIL_ROUTE,
  QUOTE_ORDER_SUBMITTED_ROUTE,
  QUOTES_ROUTES,
  REQUEST_QUOTE_SUCCESS_ROUTE,
} from "./constants";
import QuoteDetails from "./QuoteDetails";

export const quotesRoutes: RouteObject[] = [
  {
    element: (
      <FlagGate flag="quoteEnabled" redirectTo={HOME_ROUTE}>
        <ProtectedRoute mode="single" permission="Quotes_QuoteView" redirectTo={HOME_ROUTE}>
          <Outlet />
        </ProtectedRoute>
      </FlagGate>
    ),
    children: [
      { path: QUOTES_ROUTES.BASE, element: <Quotes /> },
      { path: QUOTE_DETAIL_ROUTE, element: <QuoteDetails /> },
      { path: QUOTE_ORDER_SUBMITTED_ROUTE, element: <QuoteOrderSubmitted /> },
    ],
  },
  {
    element: (
      <FlagGate flag="quoteEnabled" redirectTo={HOME_ROUTE}>
        <ProtectedRoute mode="single" permission="Quotes_QuoteRequest" redirectTo={HOME_ROUTE}>
          <Outlet />
        </ProtectedRoute>
      </FlagGate>
    ),
    children: [{ path: REQUEST_QUOTE_SUCCESS_ROUTE, element: <RequestAQuoteSuccess /> }],
  },
];
